import {
    Event,
    genericPubSub,
} from 'components/customer/RoomPlanner/helper/GenericPubSub';

/**
 * Asks the open product editor to submit its form, then runs a follow-up action
 * only if every subscriber reported a successful save.
 *
 * A subscriber may resolve late, when the save is waiting on a second dialog
 * such as the Room Assistant's "Update Product Defaults?", so the follow-up
 * runs after that outcome is known rather than being dropped.
 *
 * @param {Function} onSaved - Runs once the editor has saved, e.g. closing the
 * editor or switching to another cabinet.
 * @return {Promise<void>} Resolves once the save outcome is known.
 */
export const submitProductEditorAndContinue = async (
    onSaved?: () => void
): Promise<void> => {
    // Both call sites invoke this as `void onConfirmSave()`, so a throwing
    // subscriber would surface as an unhandled rejection. Treat it as a failed
    // save and leave the editor where it is.
    const results = await genericPubSub
        .publish(Event.ROOM_PLANNER_SUBMIT_PRODUCT_EDITOR, undefined)
        .catch(() => [false]);

    if (!results.includes(false)) {
        onSaved?.();
    }
};
